import { SURVEY_LAYERS } from '../constants/SurveyLayers';

/**
 * Supporting context layers to surface as miniatures when demand classification
 * is enabled for a given prescription source layer, keyed by country code.
 *
 * DK: P/K -> soiltype (JB); Rt -> Clay + Humus.
 * EE: PH/P/K/Mg/Cu/Mn/B -> soil class (EE_SOIL_CLASS).
 */
const MINIATURES_BY_COUNTRY: Record<string, Record<string, string[]>> = {
  DK: {
    [SURVEY_LAYERS.PHOSPHORUS]: [SURVEY_LAYERS.JB],
    [SURVEY_LAYERS.POTASSIUM]: [SURVEY_LAYERS.JB],
    [SURVEY_LAYERS.RT]: [SURVEY_LAYERS.CLAY, SURVEY_LAYERS.HUMUS],
  },
  EE: {
    [SURVEY_LAYERS.PH]: [SURVEY_LAYERS.EE_SOIL_CLASS],
    [SURVEY_LAYERS.PHOSPHORUS]: [SURVEY_LAYERS.EE_SOIL_CLASS],
    [SURVEY_LAYERS.POTASSIUM]: [SURVEY_LAYERS.EE_SOIL_CLASS],
    [SURVEY_LAYERS.MAGNESIUM]: [SURVEY_LAYERS.EE_SOIL_CLASS],
    [SURVEY_LAYERS.COPPER]: [SURVEY_LAYERS.EE_SOIL_CLASS],
    [SURVEY_LAYERS.MANGANESE]: [SURVEY_LAYERS.EE_SOIL_CLASS],
    [SURVEY_LAYERS.BORON]: [SURVEY_LAYERS.EE_SOIL_CLASS],
  },
};

/**
 * Returns every layer that can ever appear as a demand miniature for any source
 * layer in the given country. Used to strip stale miniatures when the source
 * layer changes.
 */
export function getAllDemandMiniatures(countryCode: string | null | undefined): string[] {
  if (!countryCode) {
    return [];
  }

  const countryMap = MINIATURES_BY_COUNTRY[countryCode];
  if (!countryMap) {
    return [];
  }

  const all = new Set<string>();
  Object.values(countryMap).forEach((layers) => layers.forEach((l) => all.add(l)));
  return Array.from(all);
}

export function getDefaultDemandMiniatures(
  sourceLayer: string | null | undefined,
  countryCode: string | null | undefined
): string[] {
  if (sourceLayer == null || countryCode == null) {
    return [];
  }

  const countryMap = MINIATURES_BY_COUNTRY[countryCode];
  return (countryMap && countryMap[sourceLayer]) || [];
}
